<template>
  <FKBreadCrumb :page="$t('cta.add')" :title="$t('page.add_caregiver')">
    <FKBreadCrumbItem :page="$t('page.patients')" to="/patients" />
    <FKBreadCrumbItem :page="$t('page.caregivers')" :to="`/patient/${patient_id}/caregivers`" />
  </FKBreadCrumb>
  <CaregiverForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import CaregiverForm from "@/components/FK/Caregivers/CaregiverForm.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";

export default defineComponent({
  name: "AddCaregiverPage",
  components: {
    FKBreadCrumb,
    FKBreadCrumbItem,
    CaregiverForm,
  },
  computed: {
    patient_id(): string { return this.$route.params.id as string }
  }
});
</script>